import { z } from 'zod';

export const babyCreateSchema = z.object({
  name: z.string().min(1).max(40),
  birth_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullable().optional(),
  sex: z.enum(['M', 'F']).nullable().optional(),
  ga_days: z.number().int().min(140).max(315).nullable().optional(),
});

export const babyPatchSchema = babyCreateSchema.partial();

export type BabyCreate = z.infer<typeof babyCreateSchema>;
export type BabyPatch = z.infer<typeof babyPatchSchema>;
